"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SLASH_SUBSTITUTE = exports.RULE = exports.DECLARATION = exports.COMMENT = exports.BEFORE = exports.ATRULE = exports.AFTER_BEGIN = exports.AFTER = void 0;
var RULE = 'rule';
exports.RULE = RULE;
var ATRULE = 'atrule';
exports.ATRULE = ATRULE;
var DECLARATION = 'declaration';
exports.DECLARATION = DECLARATION;
var COMMENT = 'comment';
exports.COMMENT = COMMENT;
var SLASH_SUBSTITUTE = '!';
exports.SLASH_SUBSTITUTE = SLASH_SUBSTITUTE;
var AFTER_BEGIN = 'afterBegin';
exports.AFTER_BEGIN = AFTER_BEGIN;
var BEFORE = 'before';
exports.BEFORE = BEFORE;
var AFTER = 'after';
exports.AFTER = AFTER;